import { z } from 'zod';

/** 作成画面 `/notification-policies/new?domain=` の search スキーマ */
export const PolicyCreateSearchSchema = z.object({
  domain: z.enum(['business_package', 'alert']).optional()
});